import { render, staticRenderFns } from "./CommentChat.vue?vue&type=template&id=3870bca0&scoped=true&"
import script from "./CommentChat.vue?vue&type=script&lang=js&"
export * from "./CommentChat.vue?vue&type=script&lang=js&"
import style0 from "./CommentChat.vue?vue&type=style&index=0&id=3870bca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870bca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VList,VListItem,VRow})
